
import Vue from 'vue';
import axios from 'axios';
// import router from '../router/index';
import EventBus from './EventBus';
// import store from '../store/index';

Vue.use(EventBus);

const API_URL = process.env.VUE_APP_API_URL;
axios.interceptors.request.use((config) => {
  const configuration = config;
  configuration.url = API_URL + config.url;
  // configuration.headers.common['Access-Control-Allow-Origin'] = '*';
  // let user = localStorage.getItem('user');
  // if (user) {
  //   user = JSON.parse(user);
  //   configuration.headers.common.Authorization = `Bearer ${user.token}`;
  // }
  return configuration;
});

// axios.interceptors.response.use(response => response, (error) => {
// if (!error.response) {
//   const internalError = new Promise(() => {
//     router.push({ name: 'server-error' });
//   });
//   return internalError;
// }

// const { response: { status } } = error;


//   if (status === 403) {
//     const notAllowed = new Promise(() => {
//       router.push({ name: 'acesso-negado' });
//     });
//     return notAllowed;
//   }
//   if (status === 404) {
//     const notFound = new Promise(() => {
//       router.push({ name: 'pagina-nao-encontrada' });
//     });
//     return notFound;
//   }
//   if (status === 401) {
//     if (router.history.current.path !== '/') {
//       const retornaLogin = new Promise(() => {
//         localStorage.removeItem('user');
//         store.commit('UPDATE_USER', null);
//         store.commit('UPDATE_LOGIN', false);
//         router.push('/');
//       });
//       return retornaLogin;
//     }
//   }
//   if (status === 500) {
//     const internalError = new Promise(() => {
//       router.push({ name: 'server-error' });
//     });
//     return internalError;
//   }

// return Promise.reject(error);
// });

export default (V) => {
  Object.defineProperties(V.prototype, {
    $http: {
      get() {
        return axios;
      },
      post() {
        return axios;
      },
      put() {
        return axios;
      },
      patch() {
        return axios;
      },
    },
  });
};
